import React from 'react';
import Icon from '../icons/Icons';
import styles from './Search.module.css';

/**
 * SearchBar
 * Props:
 * - value: string
 * - onChange: (e) => void
 * - placeholder?: string
 * - className?: string (defaults to 'admin-form-control')
 * - id?: string
 * - name?: string
 * - onKeyDown?: (e) => void
 */
export function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  className,
  id,
  name,
  onKeyDown,
  ...rest
}) {
  const inputClass = [styles.input, className].filter(Boolean).join(' ');
  return (
    <div className={styles.wrapper}>
        <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClass}
            id={id}
            name={name}
            onKeyDown={onKeyDown}
        {...rest}
        />
        <span className={styles.icon} aria-hidden>
            <Icon name="user_actions/search" width={24} height={24} />
        </span>
    </div>
  );
}
